module.exports = __webpack_public_path__ + "static/img/04.800c934.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/04.jpg
// module id = M/Qp
// module chunks = 0